import type { IconProps } from '../types/IconProps.ts';
export const Trash: IconProps = {
    name: 'Trash',
    children: [
        `<path d="M3 6h2m16 0h-2M8 6V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2M8 6h8M8 6H5m11 0h3M5 6v14c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V6" />`,
    ]
};